// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"d6ee6311","270":"76e96495"}[chunkId] + ".chunk.js";
};